import tippy from 'tippy.js';

document.querySelectorAll('.js-tooltip').forEach(($target) => {
  const id = $target.getAttribute('data-template');
  if (id) {
    const template = document.getElementById(id);

    if (template) {
      tippy($target, {
        content: template.innerHTML,
        allowHTML: true,
        placement: 'bottom',
        animation: 'shift-away',
        arrow: false,
        theme: 'bw',
      });
    }
  }
});
